<h1>Book Now</h1>

<div class="flex justify-content-center">
  <p-calendar
    class="max-w-full"
    [(ngModel)]="selectedDate"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [disabledDates]="disabledDates"
    (onSelect)="onSelect($event)"
    [inline]="true" />
</div>
<div class="flex justify-content-end mt-1">
  <p-button [routerLink]="[routes.SELECT_DURATION]" [disabled]="!selectedDate" label="NEXT"></p-button>
</div>